interface Props {
  version?: string;
}

export function KubeSoloVersion({ version }: Props) {
  return (
    <div className="flex items-center gap-2" data-cy="kubesolo-version">
      <span className="font-medium">
        KubeSolo {version || 'version unknown'}
      </span>
    </div>
  );
}
